// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__nID4j","amount":"Amount_amount__27mGN","tip":"Amount_tip__1zopi","tipHeader":"Amount_tipHeader__2v7EQ","tipsWrap":"Amount_tipsWrap__1QeJX"};